module.exports = __webpack_public_path__ + "img/13.c54dc0f1.jpg";